@if(reference.field_choices) {
  <div class="hierarchic-search-panel__field-toggle-container">
    <mat-button-toggle-group
      [value]="selectedSearchField()"
      (change)="toggleButtonChange($event)"
    >
      @for (option of reference.field_choices; track $index) {
        <mat-button-toggle [value]="option.query_field">
          {{ option.field_name | translate }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
}

<mat-form-field
  appearance="outline"
  class="hierarchic-search-panel__search-field"
>
  <mat-label>
    <span>
      {{ 'TRANS__HIERARCHIC_SEARCH_PANEL__SEARCH_FOR' | translate }}
    </span>

    <span>
      {{ fieldParameters.field.title | translate }}
    </span>
  </mat-label>

  <input
    #queryInput
    matInput
    type="text"
    [(ngModel)]="query.value"
    (ngModelChange)="queryChanged()"
  >

  @if (query.value) {
    <button
      type="button"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clearQuery()"
    >
      <mat-icon>
        close
      </mat-icon>
    </button>
  }
</mat-form-field>

@if (!query || !query.value) {
  <app-hierarchic-list-panel
    #listPanel
    [fieldParameters]="fieldParameters"
    [reference]="reference"
    [panelHasBeenOpened]="searchPanelOpen"
    [selectedSearchField]="selectedSearchField()"
    (nodeSelected)="nodeSelected.emit($event)"
    (nodeOpened)="nodeOpened.emit($event)"
  />
}
@else {
  <div
    class="hierarchic-search-panel__content"
    [ngClass]="{'create': fieldParameters.canAddNew}"
  >
    @if (searching) {
      <div class="hierarchic-search-panel__searching">
        <mat-progress-spinner
          mode="indeterminate"
          color="accent"
          [diameter]="16"
        ></mat-progress-spinner>

        <span>
        {{ 'TRANS__HIERARCHIC_SEARCH_PANEL__SEARCHING' | translate }}
      </span>
      </div>
    }
    @else {
        <mat-tree
          [dataSource]="dataSource"
          [treeControl]="treeControl"
          class="hierarchic-tree"
        >
          <ul>
            <mat-tree-node
              *matTreeNodeDef="let node; when: isLoadMore"
            >
              <li [class]="getDepthClass(node.level)">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="onNodeLoadMore(node); $event.stopPropagation();"
                >
                  {{ 'TRANS__HIERARCHIC_LIST__SHOW_MORE' | translate }}
                </button>
              </li>
            </mat-tree-node>

            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node
              *matTreeNodeDef="let node"
              matTreeNodeToggle
            >
              <li
                [class.hierarchic-tree__child-node] = "(treeControl.isExpanded(node) || node.level >= 1) && useNewDesign()"
                [class]="getDepthClass(node.level)"
              >
                <div class="mat-tree-node">
                  <!-- use a disabled button to provide padding for tree leaf (does not work for some reason) -->
                  <button
                    mat-icon-button
                    disabled
                    style="visibility: hidden"
                  >
                    <mat-icon class="mat-icon-rtl-mirror">
                      chevron_right
                    </mat-icon>
                  </button>

                  @if (isArray) {
                    <mat-checkbox
                      [checked]="node['$$isSelected']"
                      (change)="onNodeSelected(node, true)"
                    ></mat-checkbox>
                  }

                  <button
                    mat-button
                    type="button"
                    class="hierarchic-search-panel__node-text"
                    [disabled]="node['$$disabled']"
                    [title]="node['$$name']"
                    (click)="onNodeSelected(node, true)"
                  >
                    <span class="hierarchic-search-panel__name">
                      {{ getNodeDisplayString(node) }}
                    </span>

                    <!--@if (node.location_type_id_value) {
                      <span class="hierarchic-search-panel__name">
                        ({{ node.location_type_id_value }})
                      </span>
                    }-->

                    @if (node['authority_id_value'] === 'KulturNav') {
                      <span class="concept-authority"></span>
                    }
                  </button>

                  @if (node['description.description']) {
                    <button
                      (click)="openDescription(node)"
                      mat-icon-button
                      type="button"
                      class="hierarchic-search-panel__node-description"
                    >
                      <mat-icon>
                        info
                      </mat-icon>
                    </button>
                  }
                </div>
              </li>
            </mat-tree-node>

          <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node
              *matTreeNodeDef="let node; when: hasChild"
            >
              <li
                [class.hierarchic-tree__child-node] = "(treeControl.isExpanded(node) || node.level > 1) && useNewDesign()"
                [class]="getDepthClass(node.level)"
              >
                <div class="mat-tree-node">
                  <button
                    mat-icon-button
                    matTreeNodeToggle
                    (click)="onNodeOpened(node)"
                    type="button"
                    [attr.aria-label]="'Toggle ' + node['$$name']"
                  >
                    <mat-icon class="mat-icon-rtl-mirror">
                      {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                  </button>

                  @if (isArray) {
                    <mat-checkbox
                      [checked]="node['$$isSelected']"
                      (change)="onNodeSelected(node, false)"
                    ></mat-checkbox>
                  }

                  <button
                    mat-button
                    type="button"
                    class="hierarchic-search-panel__node-text"
                    [disabled]="node['$$disabled']"
                    [title]="node['$$name']"
                    (click)="onNodeSelected(node, false)"
                  >
                    <span class="hierarchic-search-panel__name">
                      {{ getNodeDisplayString(node) }}
                    </span>

                    <!--@if (node.location_type_id_value) {
                      <span class="hierarchic-search-panel__name">
                        ({{ node.location_type_id_value }})
                      </span>
                    }-->

                    @if (useNewDesign()) {
                      @if (getChildCount(node)) {
                        <span class="hierarchic-search-panel__children-counter">
                          {{ getChildCount(node) }}
                            @if (getChildCount(node) === 1) {
                              {{ 'TRANS__HIERARCHIC_LIST__CHILDREN_COUNT_ONE' | translate }}
                            }
                            @else if (getChildCount(node) > 1) {
                              {{ 'TRANS__HIERARCHIC_LIST__CHILDREN_COUNT_MORE' | translate }}
                            }
                        </span>
                      }
                    }


                    @if (node['authority_id_value'] === 'KulturNav') {
                      <span class="concept-authority"></span>
                    }
                  </button>

                  @if (node['description.description']) {
                    <button
                      (click)="openDescription(node)"
                      mat-icon-button
                      type="button"
                      class="hierarchic-search-panel__node-description"
                    >
                      <mat-icon>
                        info
                      </mat-icon>
                    </button>
                  }
                </div>

                @if (useNewDesign()) {
                  <ul
                    class="hierarchic-search-panel__node-children-unpadded"
                    [class.hierarchic-tree-invisible]="!treeControl.isExpanded(node)"
                  >
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul>
                }
                @else {
                  <ul
                    class="hierarchic-search-panel__node-children"
                    [class.hierarchic-tree-invisible]="!treeControl.isExpanded(node)"
                  >
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul>
                }
              </li>
            </mat-nested-tree-node>
          </ul>
        </mat-tree>
    }

    @if (!query.value) {
      <div class="hierarchic-search-panel__feedback">
      <span>
        {{ 'TRANS__HIERARCHIC_SEARCH_PANEL__NO_SEARCH' | translate }}
      </span>
      </div>
    }

    @if (!searching && dataSource.data.length === 0 && query.value) {
      <div class="hierarchic-search-panel__feedback">
      <span>
        {{ 'TRANS__HIERARCHIC_SEARCH_PANEL__NO_SEARCH_HITS' | translate }}
      </span>
      </div>
    }
  </div>
}
